import React, { Component } from 'react';
import { connect } from 'react-redux';


import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('APPLICATION_ERROR_HIGHLIGHTER', LOG_LEVELS.ERROR);

class HighlightOnInAppMessage extends Component {
  render() {
    log.debug('render(): ', this.props);
    if (!this.props.children) return (<div></div>);
    const errorIsActive = this.props.messages.length > 0 && this.props.messageType === 'applicationError';
    return (
      <div className={errorIsActive ? 'error' : ''}>
        {this.props.children}
      </div>
    );
  }
}


HighlightOnInAppMessage.defaultProps = {
  messageType: 'applicationError'
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppMessages = (state.logger && state.logger.inAppMessages) || [];

  const types = Array.isArray(props.types) ? props.types : typeof props.types === 'string' ? [props.types] : undefined;
  
  const scopes = Array.isArray(props.scopes) ? props.scopes : typeof props.scopes === 'string' ? [props.scopes] : undefined;
  const messageIds = Array.isArray(props.messageIds) ? props.messageIds : typeof props.messageIds === 'number' ? [props.messageIds] : undefined;
  const messages = inAppMessages.filter((entry) => {
    return entry.message && (!types || types.indexOf(entry.message.type) >=0 ) && (!scopes || scopes.indexOf(entry.scope) >= 0) && (!messageIds || messageIds.indexOf(entry.message.id) >=0);
  });
  const messagesByType = messages.reduce((byType, entry) => {
    if (!entry && !entry.message) {
      return byType;
    }
    if (!byType[entry.message.type]) {
      byType[entry.message.type] = []
    }
    byType[entry.message.type].push(entry);
    return byType;
  }, {});
  return {
    messages,
    messagesByType
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(HighlightOnInAppMessage);